export default __webpack_public_path__ + "static/mobile-2c0c79cc80e291624ce672b8d1e0fb82.svg";